import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { UsersTable as UT } from '../../features/users'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function UsersTable(props: RouteProps) {
  const { setTitle } = useTitleHeaderContext()
  setTitle(props.title || '')

  return <UT />
}
